import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";
import { invalidateVenueMarketCache } from "@/hooks/useVenueMarket";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = anonymous, object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("st_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem("st_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await http.post("/auth/logout");
    } catch {
      // ignore
    }
    localStorage.removeItem("st_token");
    invalidateVenueMarketCache();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
